<template lang='pug'>
    #sessao-indicadores-dashboard-operacao
        h2.mb-4 {{ $t('mensagens.operacao.dashboard.indicadores') }}

        el-skeleton(:rows='1' :loading='loading' animated)
            template(v-slot:template)
                .sessao-indicadores-dashboard-operacao__cards
                    el-skeleton-item.sessao-indicadores-dashboard-operacao__cards__skeleton(
                        variant="react"
                        v-for='(__, index) in loadingSkeleton'
                        :key='index'
                    )

            template
                .sessao-indicadores-dashboard-operacao__cards
                    .sessao-indicadores-dashboard-operacao__cards-card(
                        v-if='erro'
                        v-for='(item, index) in errorPayload'
                        :style='{ backgroundColor: item.corCard }'
                        :key='index'
                    )
                        div.sessao-indicadores-dashboard-operacao__cards-card__titulo
                            span --
                        div.sessao-indicadores-dashboard-operacao__cards-card__descricao
                            span {{ $t('mensagens.operacao.dashboard.semInfo') }}

                    .sessao-indicadores-dashboard-operacao__cards-card(
                        v-if='!erro'
                        v-for='(item, index) in payload'
                        :style='{ backgroundColor: item.corCard }'
                        :key='index'
                    )
                        el-tooltip(placement='top', :content="item.tooltip")
                            div
                                div.sessao-indicadores-dashboard-operacao__cards-card__titulo
                                    span {{ item.porcentagem ? item.porcentagem : '--' }}
                                div.sessao-indicadores-dashboard-operacao__cards-card__descricao(v-if='item.descricao')
                                    span {{ $t(`mensagens.operacao.dashboard.${item.codigo}`) }}
</template>

<script>
export default {
    name: 'SessaoIndicadoresDashboardOperacao',
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        payload: {
            type: Array,
            required: true,
            default: () => ([{
                corCard: null,
                tooltip: null,
                porcentagem: null,
                descricao: null
            }])
        },
        erro: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        loadingSkeleton: [{}, {}, {}, {}],
        errorPayload: [{}, {}, {}, {}]
    })
};
</script>

<style lang='scss' scoped>
#sessao-indicadores-dashboard-operacao {
    width: 100%;

    .sessao-indicadores-dashboard-operacao__cards {
        display: flex;
        width: 100%;
        gap: 20px;

        .sessao-indicadores-dashboard-operacao__cards-card {
            height: 80px;
            width: 100%;
            padding: 10px;
            background: #5555553A;
            border-radius: 5px;
            text-align: center;
            box-shadow: 0 1px 3px 0 var(--block-shadow);

            .sessao-indicadores-dashboard-operacao__cards-card__titulo {
                font-size: 26px;
                font-weight: 600;
            }

            .sessao-indicadores-dashboard-operacao__cards-card__descricao {
                font-size: 14px;
                font-weight: 600;
            }
        }

        .sessao-indicadores-dashboard-operacao__cards__skeleton {
            height: 80px;
            border-radius: 5px;
            width: 100%;
        }
    }

}
</style>
